module.exports = "http://cdn.realive.com.ua/src/views/player/help/images/2472.jpg";